import Projects from "../../views/modules/projects/Projects";
import Project from "../../views/modules/projects/Project";
import roles from "@/roles";
import CustomersListproj from "../../components/customers/CustomersList";
import DocumentList from "../../views/modules/projects/documents/DocumentList";
import Providers from "../../views/modules/projects/Providerlist";
import OrderBuyP from "../../views/modules/projects/OrderBuyP";
import InventoryIntemp from "../../views/modules/projects/InventoryIntemp";
import contract from "@/views/modules/projects/contract-line.vue";
import projectsreport from "../../views/modules/projects/ProjectReport.vue";
// reports

import layouts from "../../layout";
// import store from "@/store";
// import { COMPANYS } from "@/const";

export default {
  path: "/projects",
  name: "projects",
  component: Projects,
  meta: {
    auth: true
  },
  redirect: {
    name: "projects-kpi"
  },
  children: [
    {
      path: "project",
      name: "projects-kpi",
      component: Project,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Proyectos",
        tags: ["projects", "project"],
        index: true
      }
    },
    {
      path: "Provider",
      name: "projects-provider",
      component: Providers,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Proveedores",
        tags: ["project", "provider"],
        index: true
      }
    },
    {
      path: "OderBuy",
      name: "Projects-OrderBuy",
      component: OrderBuyP,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Order Buy",
        tags: ["project", "orderbuy"],
        index: true
      }
    },
    {
      path: "inventoryI",
      name: "projects-InventoryI",
      component: InventoryIntemp,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Inventory",
        tags: ["project,Inventory"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario,
          roles.Proyectos
        ]
      }
    },
    {
      path: "customersproj",
      name: "sales-customers-pro",
      component: CustomersListproj,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Sales Customers",
        tags: ["customer,project"],
        index: true,
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario,
          roles.Proyectos
        ]
      }
    },
    {
      path: "documents",
      name: "projects-documents",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Document",
        tags: ["finances", "documents"],
        index: true
      }
    },
    {
      path: "contract-line",
      name: "Linea Contrato",
      component: contract,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Linea Contrato",
        index: true,
        tags: ["project"],
        roles: [
          roles.SoporteVentas,
          roles.EjecutivoDeVentas,
          roles.CEO,
          roles.SuperUsuario,
          roles.Proyectos
        ]
      }
    },
    {
      path: "Reporte",
      name: "projects-Reporte",
      component: projectsreport,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Reporte de rentabilidad de proyectos",
        index: true,
        tags: ["project"]
      }
    }
    // {
    //   path: "reportsurvey",
    //   name: "employees-reportsurvey",
    //   component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Respuesta de Empleados",
    //     index: true,
    //     // Pass props to the component
    //     props: {
    //       // Define your props here
    //       prop1: "value1",
    //       prop2: "value2"
    //       // ...,
    //     }
    //   }
    // }
  ]
};
